import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/rc/enums';
import { textOverflowHidden } from '@picsart/rc/helpers';
import { isLeftToRight, isRightToLeft } from '@picsart/design-system/foundation/styleHelpers';
import { FontSizes, FontWeights } from '@picsart/rc/fonts';

const useShareButtonsStyles = createUseStyles(
  {
    root: {
      listStyleType: 'none',
      '&.compact': {
        display: 'flex',
        justifyContent: 'space-between',
        gap: `${Spacings.Size_6}px`,
        height: 48,
      },
    },
  },
  {
    name: 'share-buttons',
  },
);

const useShareButtonStyles = createUseStyles(
  {
    root: {
      display: 'flex',
      height: '44px',
      marginBottom: `${Spacings.Size_6}px`,
      position: 'relative',

      [isLeftToRight]: {
        paddingLeft: '52px',
      },
      [isRightToLeft]: {
        paddingRight: '52px',
      },

      '&.is-list': {
        [isLeftToRight]: {
          paddingRight: '28px',
        },
        [isRightToLeft]: {
          paddingLeft: '28px',
        },
      },

      '&:hover': {
        cursor: 'pointer',
      },

      '&.compact': {
        display: 'inline-block',
        padding: 0,
        marginBottom: 0,
        height: 48,
        width: 48,
      },
    },
    listItemIconHolder: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '36px',
      height: '36px',
      position: 'absolute',
      top: 0,
      bottom: 0,
      margin: 'auto 0',

      '&.general': {
        borderRadius: '50%',
        backgroundColor: '#EDEEF4',
      },

      '&.brand': {},

      '&.compact': {
        height: 48,
        width: 48,
      },

      [isLeftToRight]: {
        left: 0,
      },
      [isLeftToRight]: {
        right: 0,
      },
    },
    listItemTitle: {
      display: 'block',
      flex: '1 1 auto',
      fontWeight: FontWeights.SemiBold,
      fontSize: FontSizes.Size_6,
      color: '#282B36',
      ...textOverflowHidden,
      textTransform: 'capitalize',
      lineHeight: '44px',
    },
  },
  {
    name: 'share-button',
  },
);

export { useShareButtonsStyles, useShareButtonStyles };
